export default __webpack_public_path__ + "static/media/Nomura_logo.8550d548.png";